/**
 * useTheme — фасад над `atoms/theme/`. Отдаёт текущий effective mode
 * и сеттер user-choice. Для UI-токенов через `useEffectiveTheme()`.
 */

import {useAtom, useAtomValue} from 'jotai';

import {effectiveThemeAtom, type ThemeChoice, themeChoiceAtom} from '@atoms/theme';
import type {ThemeMode} from '@styles/tokens';

export const useThemeChoice = (): [ThemeChoice, (next: ThemeChoice) => void] => {
  return useAtom(themeChoiceAtom);
};

export const useEffectiveTheme = (): ThemeMode => useAtomValue(effectiveThemeAtom);
